import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'
import TypingAnimationWrapper from '@components/Chatbot/messages/TypingEffectWrapper'

const StyledLoaderWrapper = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small2: { bundledCSS: small2BodyCopy },
        },
      },
    },
  }) => css`
    display: flex;
    gap: 9px;
    min-height: 26px;

    & > span {
      ${small2BodyCopy}
    }
  `}
`

const Loader: FunctionComponent = () => {
  const texts = useRef<string[]>([
    translate('aiSearch.answerMessage.loading1'),
    translate('aiSearch.answerMessage.loading2'),
    translate('aiSearch.answerMessage.loading3'),
  ])
  const [text, setText] = useState(texts.current[0])

  const textGenerator = useCallback(function* (texts: string[]) {
    let index = 1
    while (true) {
      yield texts[index]
      index = (index + 1) % texts.length
    }
  }, [])
  const textGeneratorRef = useRef(textGenerator(texts.current))

  useEffect(() => {
    const interval = setInterval(() => {
      setText(textGeneratorRef.current.next().value)
    }, 2500)
    return () => clearInterval(interval)
  }, [])

  return (
    <StyledLoaderWrapper>
      <TypingAnimationWrapper text={text} />
    </StyledLoaderWrapper>
  )
}

export default Loader
